<template>
  <div class="ex-card" :class="{'card-transparent' : transparent}">
    <div class="ex-card-header">
      <slot name="header"></slot>
    </div>
    <div class="ex-card-body" :class="{'pa-0' : disableOffsets}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    header: {
      type: String,
      default: ''
    },
    transparent: {
      type: Boolean,
      default: false
    },
    disableOffsets: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/Card.vue